export default [
    'title',
    'reference',
    'content',
    's_unit',
    'dueDate'
]